import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';
import { mapState, mapGetters } from 'vuex';
import { WorkerOnBoardingRoutesMixin } from '@/portal/worker-on-boarding/mixins';
import { WorkerService } from '@/core/worker';

// @vue/component
export default {
  components: {
    ProgressFooterToolbar,
  },
  mixins: [
    WorkerOnBoardingRoutesMixin,
  ],
  data() {
    return {
      selectedSetup: null,
    };
  },
  computed: {
    ...mapState(['vendorUser']),
    ...mapGetters({
      businessName: 'workerOnBoarding/selectedBusinessName',
      businessNumber: 'workerOnBoarding/selectedBusinessNumber',
    }),
    setupOptions() {
      return [{
        route: this.routes.emailReminderSent,
        label: `I'll set up this business later`,
        action: this.completeRegistration,
      }, {
        route: this.routes.sendInvitations,
        label: `Invite someone to help`,
        action: () => '',
      }];
    },
  },
  created() {
    if (!this.businessName) {
      this.$router.replace(this.routes.businessSearch);
    }
  },
  methods: {
    async redirect() {
      if (this.selectedSetup) {
        await this.selectedSetup.action();
        this.$router.push(this.selectedSetup.route);
      }
    },
    async completeRegistration() {
      try {
        const workerUuid = _.get(this.vendorUser, 'worker.uuid');
        const requestParams = {
          client_uuid: this.$route.query.client_uuid,
          trading_name: this.businessName,
          business_number: this.businessNumber,
        };

        await WorkerService.completeRegistration(workerUuid, requestParams);
      } catch (error) {
        // Do nothing
      }
    },
  },
};
